import { createSlice } from '@reduxjs/toolkit'

export const customerTreeViewSlice = createSlice({
    name: 'customerTreeView',
    initialState: {
        check: {
            ids: [],
            idField: 'value',
            applyCheckIndeterminate: true,
        },
        expand: {
            ids: [],
            idField: 'text',
        },
        entityCount: 0,
        entityMaxPixels: 0,
        filter: '',
        lastDataRetrieval: null,
        nodes: [
            {
                text: 'Your Sites:',
                value: '-1',
                disabled: true,
            },
        ],
        listViewLoading: false,
    },
    reducers: {
        custTreeViewAPIDataAdded: (state, action) => {
            state.nodes = action.payload.nodes
            state.check = action.payload.check
            state.entityCount = action.payload.entityCount
            state.entityMaxPixels = action.payload.entityMaxPixels
            state.filter = ''
            state.lastDataRetrieval = action.payload.lastDataRetrieval
        },
        custTreeViewCheckChanged: (state, action) => {
            state.check = action.payload
        },
        custTreeViewExpandChanged: (state, action) => {
            state.expand = action.payload
        },
        custTreeViewFilterChanged: (state, action) => {
            state.filter = action.payload
        },
        custTreeViewListLoading: (state, action) => {
            state.listViewLoading = action.payload
        },
    },
})

// Action creators are generated for each case reducer function
export const {
    custTreeViewAPIDataAdded,
    custTreeViewCheckChanged,
    custTreeViewExpandChanged,
    custTreeViewFilterChanged,
    custTreeViewListLoading,
} = customerTreeViewSlice.actions

export default customerTreeViewSlice.reducer
